<template>
  <div>
    <div v-if="loading" class="wg-row" style="margin:10px;justify-content:center;">
      <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)"/>
    </div>
    <template v-else>
      <project-header :selected="selectedPage" @selectPage="changePage"></project-header>
      <!-- Sub-component is rendered dynamically depending on header selected option -->
      <div class="vertical-height-div" style="height:47px;"></div>
      <!-- CONTENT AREA -->
      <div class="wg-row" style="align-items:center;flex-wrap:nowrap;">
        <div
          :style="{width: mainWidth, position: 'relative', paddingRight: windowWidth >= 992 ? '5px' : ''}"
        >
          <component
            v-if="!loading && project"
            :is="selectedComponent"
            :expBoard="expBoard"
            :projectId="project.idWorldProject"
            :customerManager="customerManager"
            :action="action"
            :boardOpen="boardOpen"
            @selectPage="changePage(...arguments)"
            @resetAction="resetAction"
            @openBoard="toggleBoard"
          >
            <project-title :projectId="project.idWorldProject" :customerManager="customerManager"></project-title>
          </component>
        </div>
        <!-- Visualizzazione bacheca come div laterale -->
        <template v-if="windowWidth >= 992">
          <div class="open-icon-div" @click="toggleBoard">
            <img
              v-if="windowWidth >= 992"
              :src="!boardOpen ? $anm22.icons.getWorldIcon('arrowLeft') : $anm22.icons.getWorldIcon('arrowRight')"
            >
          </div>
          <!-- v-show con caricamento nuovi messaggi periodico ?? -->
          <!-- <transition name="slide"> -->
          <project-board
            v-if="project"
            :expBoard="expBoard"
            :boardOpen="boardOpen"
            :projectId="project.idWorldProject"
          ></project-board>
          <!-- </transition> -->
        </template>
        <!-- Apertura con popup su mobile -->
        <template v-else>
          <wg-modal
            :width="windowWidth > 700 ? '700px' : '90%'"
            v-if="boardOpen"
            @closeModal="toggleBoard"
          >
            <div
              slot="header"
              style="font-size:22px;"
            >{{ $anm22.strLang(lang, 'Board', 'Bacheca') }}</div>
            <project-board slot="body" :expBoard="expBoard" :projectId="project.idWorldProject"></project-board>
          </wg-modal>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProjectHeader from "../components/project/ProjectHeader.vue";
import ProjectTitle from "../components/project/ProjectTitle.vue";
// import SmartView from './SmartView.vue';
import Tasks from "./Tasks.vue";
import Events from "./Events.vue";
import Expenses from "./Expenses.vue";
import Statistics from "./Statistics.vue";
import ProjectBoard from "../components/project/ProjectBoard.vue";
import Spinner from "vue-simple-spinner";

export default {
  data() {
    return {
      expBoard:false,
      loading: false,
      projectId: 0,
      mobile: /*this.$anm22.getCookie('tk_pv') === 's' ? true :*/ false,
      selectedPage:
        /*this.$anm22.getCookie('tk_pv') === 's' ? 'smartView' : */ "tasks",
      selectedComponent:
        /*this.$anm22.getCookie('tk_pv') === 's' ? 'SmartView' :*/ "Tasks",
      action: "",
      boardOpen: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      windowWidth: state => state.windowWidth
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    customerManager() {
      let result = false;
      if(this.project) {
        this.project.developers.forEach(work => {
          const e = this.$store.getters["employments/get"](this.user.idWorldUser+'-'+work);
          if(e && e.clients.reduce(
            (res, c) => res || (this.project.customers.includes(c.contact) && c.isManager), 
            false
          )) {
            result = true;
          }
        });
      }
      return result;
    },
    mainWidth() {
      if(this.windowWidth < 992) {
        return '100%';
      } else {
        if(this.boardOpen) {
          if (this.expBoard) {
            return 'calc(61% - 22px)';
          } else {
            return 'calc(75% - 22px)';
          }
        }
        else {
          return 'calc(100% - 22px)';
        }
      }
    }
  },
  components: {
    ProjectHeader,
    ProjectTitle,
    Tasks,
    Events,
    Expenses,
    Statistics,
    // SmartView: () => import("./SmartView.vue"),
    ProjectBoard,
    "vue-simple-spinner": Spinner
  },
  methods: {
    toggleBoard() {
      this.boardOpen = !this.boardOpen;
      this.$anm22.setCookie(
        "tk_board",
        this.boardOpen ? "open" : "closed",
        31536000
      );
    },
    changePage(id, action) {
      this.$Progress.start();
      if (action) {
        this.action = action;
      }
      this.selectedPage = id;
      this.selectedComponent = this.$anm22.capitalizeFirst(id);
    },
    resetAction() {
      this.action = "";
    },
    // changeMode() {
    //   if (this.mobile) {
    //     //Setto il cookie per caricare la pagina normale
    //     this.$anm22.setCookie(
    //       "tk_pv",
    //       "r",
    //       this.$moment()
    //         .add(1, "year")
    //         .utc()
    //         .unix()
    //     );
    //     this.mobile = false;
    //     this.changePage("tasks");
    //   } else {
    //     this.$anm22.setCookie(
    //       "tk_pv",
    //       "s",
    //       this.$moment()
    //         .add(1, "year")
    //         .utc()
    //         .unix()
    //     );
    //     this.mobile = true;
    //     this.changePage("smartView");
    //   }
    // },
    async loadOffline() {
      await Promise.all([
        this.$store.dispatch("projects/load", this.$vlf("projects")),
        this.$store.dispatch("employments/load", this.$vlf("employments")),
        this.$store.dispatch(
          "projectCategories/load",
          this.$vlf("projectCategories")
        ),
        this.$store.dispatch("works/load", this.$vlf("works")),
        this.$store.dispatch("users/load", this.$vlf("users")),
        this.$store.dispatch("contacts/load", this.$vlf("contacts")),
        this.$store.dispatch("places/load", this.$vlf("places")),
        this.$store.dispatch("licenses/load", this.$vlf("licenses"))
      ])
      if(this.project) {
        //elaborazione in aggiunta a 'afterEach' hook nel router
        document.title = this.project.name + ' | ANM22 Tasks';
        this.$store.dispatch(
          "headbar/setHeadbarTitle",
          this.$anm22.getProjectFullLabel(this.project)
        );
        //Termino il caricamento della barra progressiva
        this.$Progress.finish();
        this.loading = false;
      }
    },
    async loadOnline() {
      try {
        const response = await this.$http.get("project?idProject=" + this.projectId);
        if(response.data) {
          if (response.data.error) {
            //Cancello i riferimenti locali al progetto che ho cercato, non ho l'autorizzazione
            this.$store.dispatch("projects/delete", {
              vlf: this.$vlf("projects"),
              obj: this.project
            });
            this.$router.push('/');
          } else {
            await Promise.all([
              this.$store.dispatch("projects/update", {
                vlf: this.$vlf("projects"),
                objs: response.data.projects
              }),
              this.$store.dispatch("employments/update", {
                vlf: this.$vlf("employments"),
                objs: response.data.employments
              }),
              this.$store.dispatch("projectCategories/update", {
                vlf: this.$vlf("projectsCategories"),
                objs: response.data.projectCategories
              }),
              this.$store.dispatch("works/update", {
                vlf: this.$vlf("works"),
                objs: response.data.works
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: response.data.users
              }),
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: response.data.contacts,
                cleanFilters: []
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: response.data.places,
                cleanFilters: []
              }),
              this.$store.dispatch("licenses/update", {
                vlf: this.$vlf("licenses"),
                objs: response.data.licenses
              }),
            ]);
          }
          if(!this.project) {
            this.$router.push('/');
          }
          document.title = this.$anm22.getProjectFullLabel(this.project) + ' | ANM22 Tasks';
          this.$store.dispatch(
            "headbar/setHeadbarTitle",
            this.$anm22.getProjectFullLabel(this.project)
          );
        } else {
          if (this.project) {
            //Cancello i riferimenti locali al progetto che ho cercato, non ho l'autorizzazione
            this.$store.dispatch("projects/delete", {
              vlf: this.$vlf("projects"),
              obj: this.project
            });
          }
          this.$router.push("/");
        }
      } catch(e) {

      } finally {
        this.$Progress.finish();
        this.loading = false;
        if (this.$route.query.page) {
          if(this.$route.query.action) {
            this.changePage(this.$route.query.page, this.$route.query.action);
          } else {
            this.changePage(this.$route.query.page);
          }
        }
      }
    }
  },
  created() {
    this.projectId = this.$route.params.id;
    this.loading = true;
    this.loadOffline();
    this.loadOnline();
  },
  mounted() {
    this.boardOpen =
      this.$anm22.getCookie("tk_board") !== "" &&
      this.windowWidth >= 992 &&
      this.$anm22.getCookie("tk_board") == "open";
  },
  watch: {
    $route(to, from) {
      this.projectId = this.$route.params.id;
      this.loading = true;
      this.loadOnline();
    }
  }
};
</script>

<style lang="scss" scoped>
.open-icon-div {
  cursor: pointer;
  position: relative;
  height: calc(100vh - 108px);
  width: 22px;
  z-index: 40;
  border-left: 1px solid #ddd;
  &:hover img {
    opacity: .8;
  }
  & img {
    opacity: 0.4;
    position: absolute;
    top: 50%;
    left: 0;
    height: 20px;
  }
}
</style>

<style lang="scss">
@media print {
  .anm22-task-headmenu,
  .anm22_template_anm22it_2014_headBar,
  #anm22_world_menu_small,
  .open-icon-div {
    display: none !important;
  }
  .com-anm22-app-outer-wrapper {
    padding:0 !important;
  }
  .com-anm22-app-scrolling-panel {
    height: auto !important;
  }
}
</style>

